module.exports = __webpack_public_path__ + "static/img/03.4bda1c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/03.jpg
// module id = uBcl
// module chunks = 1